export default __webpack_public_path__ + "static/media/login_bg.bf604adf.jpg";